import moment from 'moment'
import update from 'immutability-helper'
import {mapKeys, findIndex} from 'lodash'
import React from 'react'
import Text from 'react-text'
import {Consumer} from '../../../context'
import UploadLinks from './upload-links'
import prettyBytes from 'pretty-bytes'
import {enhancedWithRowData, enhancedWithSortColumns} from '../../../helpers/utils'


function UploadColumn ({rowData}) {
  const {id: uploadId, name} = rowData
  return (<Consumer>{context => {
    const {newPlan} = context
    const {content = {}} = newPlan
    const {lessons: planLessons = []} = content
    const index = findIndex(planLessons, ({id}) => uploadId == id)
    const assigned = index >= 0
    const assignedClass = `lesson-name${assigned ? ' assigned' : ''}`
    const title = context.translate(assigned ? 'remove-lesson-from-plan' : 'add-lesson-to-plan')
    return (
      <div className={assignedClass} title={title} onClick={() => {
        const lessons = update(planLessons, assigned
          ? {$splice: [[index,1]]}
          : {$push: [{id: uploadId, name}]})
        context.setState({newPlan: {...newPlan, content: {...content, lessons}}})
      }}>
        <div className="bullet"></div>
        <div className="code">{name}</div>
      </div>
    )
  }}</Consumer>)
}

function MyLessonsHeader ({sortColumns, title}) {
  const active = sortColumns && sortColumns.id == title
  const direction = active ? (sortColumns.sortAscending ? 'ascending' : 'descending') : ''
  return (
    <span className="sorted-column-wrapper">
      <span className={direction}/>
      <span><Text id={`${title}_my_lessons_header`} /></span>
    </span>
  )
}

function EmptyHeader () { return (<span />) }


function ByteLengthColumn ({value}) {
  return (<div className="size">{prettyBytes(value || 0)}</div>)
}

function DateColumn ({value}) {
  return (<div className="modified">{moment(value).format('L, LT')}</div>)
}

function LessonLinksColumn ({rowData}) {
  const map = { lesson: 'id', lessonName: 'name'}
  const props = mapKeys(rowData, (_, key) => map[key] || key)
  return (<UploadLinks {...props} />)
}

const map = {
  headers: {MyLessonsHeader: enhancedWithSortColumns(MyLessonsHeader), EmptyHeader},
  columns: {
    UploadColumn: enhancedWithRowData(UploadColumn),
    LessonLinksColumn: enhancedWithRowData(LessonLinksColumn),
    ByteLengthColumn,
    DateColumn
  }
}

export default map
